import React from 'react';
import { ScenarioStatus } from '../types';

interface ScenarioStatusBadgeProps {
  status: ScenarioStatus | string;
}

export const ScenarioStatusBadge: React.FC<ScenarioStatusBadgeProps> = ({ status }) => {
  const norm = (status || 'DRAFT').toUpperCase();

  if (norm === 'PUBLISHED') {
    return (
      <span className="admin-status-badge admin-status-badge--active">
        <span className="admin-status-dot" />
        Published
      </span>
    );
  }

  if (norm === 'ARCHIVED') {
    return (
      <span className="admin-status-badge admin-status-badge--suspended">
        <span className="admin-status-dot" />
        Archived
      </span>
    );
  }

  return (
    <span className="admin-status-badge admin-status-badge--pending">
      <span className="admin-status-dot" />
      Draft
    </span>
  );
};
